function CheckExpiry() {
  const currentDateTime = new Date();
  const tokenExpiration = new Date(localStorage.getItem("tokenExp"));
  return currentDateTime > tokenExpiration;
}

export default CheckExpiry;
